/*eslint no-console: 0*/

import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, FormattedHTMLMessage, IntlShape} from 'react-intl';
import config from '../../common/config';

import LoadingButton from '../fw/LoadingButton.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';

import SetChannelConfidentialMutation from './SetChannelConfidentialMutation.react';

import {wrapNotFound} from '../app/NotFoundHandler.react';
import EventTracker from '../app/EventTracker';
import mutationError from '../channel-defs/mutationError';
import {safeJSONparse} from "../../common/util/safeJSONparse";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';


interface SetChannelConfidentialProps {
 intl?: object;
 relay?: object;
 user: User;
}


class SetChannelConfidential extends React.Component<SetChannelConfidentialProps> {

    typeName = 'channels';

    static propTypes = {
        intl: PropTypes.object,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };
    static contextTypes = {
        router: PropTypes.object
    };

    constructor() {
        super();
    }

    onClickSetChannelConfidential = () => {
        return new Promise((resolve, reject) => {
            const data = this.props.user.organisation.channel;

            EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                event: 'channel-set-channel-confidential',
                type: 'application'
            });

            let onFailure = (transaction) => {
                mutationError(transaction);
                reject();
            };

            let onSuccess = (response) => {

                let type = types[this.typeName];

                let path = urlMapping.getUrl(type, "view", data);
                this.context.router.push(path);

                resolve();
            };

            // To perform a mutation, pass an instance of one to `Relay.Store.commitUpdate`
            Relay.Store.commitUpdate(new SetChannelConfidentialMutation({channel: data, confidential: data.confidential ? false : true}), {
                onFailure,
                onSuccess
            });
        });
    };


    render() {
        const data = this.props.user.organisation.channel;
        let type = types[this.typeName];

        let metadata = safeJSONparse(data.metadata);

        let title = data.channelDef.name;
        if (data.name) {
            title += ' - ' + data.name;
        }

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } className="ChannelView" title={title}>
                <h3><FormattedMessage defaultMessage="Confidential mode" id="channelConfidential.title" /></h3>

                <FormattedHTMLMessage defaultMessage="<p>If you are worried about your data, you can activate confidential mode. No data will be stored in {productName} and your data will not even be logged. And we will delete all cached data including API requests.</p>" id="channelConfidential.explanation" values={{productName: config.PRODUCT_NAME}}/>

                {metadata.canConfidential ?
                    <div style={{paddingTop: '1em'}}>{data.confidential ?
                        <LoadingButton className="btn btn-primary" onClick={this.onClickSetChannelConfidential}><i aria-hidden="true" className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Disable confidential mode" id="channel.disableConfidential" /></LoadingButton>
                    :
                        <LoadingButton className="btn btn-primary" onClick={this.onClickSetChannelConfidential}><i aria-hidden="true" className="fa fa-fw fa-user-secret"></i> <FormattedMessage defaultMessage="Activate confidential mode" id="channel.enableConfidential" /></LoadingButton>
                    }</div>
                :
                    <div>
                        <FormattedMessage defaultMessage="Confidential mode is not possible for this Application." id="application.confidentialModeNotPossible" />

                    </div>
                }

            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(SetChannelConfidential), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    featureFlags,
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        type,
                        cachingStatus,
                        confidential,
                        description,
                        name,
                        metadata,
                        channelDef {
                            id,
                            name,
                            description,
                            icon,
                        },
                        ${SetChannelConfidentialMutation.getFragment('channel')}
                    }
                }
            }
        `,
    },
});
